import { Link, useNavigate } from "react-router-dom";
import { ShoppingBag, User, LogOut, Shield } from "lucide-react";
import { useCart } from "@/context/CartContext";
import { useAuth } from "@/context/AuthContext";

export const Navbar = () => {
  const { count } = useCart();
  const { user, logout } = useAuth();
  const navigate = useNavigate();

  return (
    <header className="sticky top-0 z-50 border-b border-black/10 bg-[#f7f3ec]/80 backdrop-blur-xl">
      <div className="mx-auto flex max-w-7xl items-center justify-between px-6 py-5">
        <Link to="/" data-testid="nav-logo" className="flex items-center gap-2">
          <span className="ha-logo ha-logo-sm text-2xl tracking-tight">
            The Good Life
          </span>
        </Link>

        <nav className="hidden items-center gap-10 md:flex">
          <Link
            to="/shop?c=flower"
            data-testid="nav-flower"
            className="text-sm font-medium text-neutral-600 transition-colors duration-300 hover:text-[#a06d34]"
          >
            Flower
          </Link>
          <Link
            to="/shop?c=blunt"
            data-testid="nav-blunts"
            className="text-sm font-medium text-neutral-600 transition-colors duration-300 hover:text-[#a06d34]"
          >
            Blunts
          </Link>
          <Link
            to="/shop?c=concentrate"
            data-testid="nav-concentrates"
            className="text-sm font-medium text-neutral-600 transition-colors duration-300 hover:text-[#a06d34]"
          >
            Concentrates
          </Link>
          <Link
            to="/shop"
            data-testid="nav-shop"
            className="text-sm font-medium text-neutral-600 transition-colors duration-300 hover:text-[#a06d34]"
          >
            Shop All
          </Link>
          <Link
            to="/coa"
            data-testid="nav-coa"
            className="flex flex-col items-center leading-none text-neutral-600 transition-colors duration-300 hover:text-[#a06d34]"
          >
            <span className="text-sm font-medium">COA</span>
            <span className="mt-0.5 text-[9px] uppercase tracking-widest text-[#a06d34]">(Lab Tested)</span>
          </Link>
        </nav>

        <div className="flex items-center gap-5">
          {["admin", "owner", "manager", "employee"].includes(user?.role) && (
            <Link
              to="/admin"
              data-testid="nav-admin"
              className="hidden items-center gap-1 text-sm text-neutral-600 transition-colors hover:text-[#a06d34] sm:flex"
            >
              <Shield className="h-4 w-4" strokeWidth={1.5} /> Staff
            </Link>
          )}
          {user ? (
            <>
              <Link
                to="/account"
                data-testid="nav-account"
                className="text-neutral-600 transition-colors hover:text-[#a06d34]"
              >
                <User className="h-5 w-5" strokeWidth={1.5} />
              </Link>
              <button
                data-testid="nav-logout"
                onClick={() => {
                  logout();
                  navigate("/");
                }}
                className="text-neutral-600 transition-colors hover:text-[#a06d34]"
              >
                <LogOut className="h-5 w-5" strokeWidth={1.5} />
              </button>
            </>
          ) : (
            <Link
              to="/auth"
              data-testid="nav-login"
              className="text-sm font-medium text-neutral-600 transition-colors duration-300 hover:text-[#a06d34]"
            >
              Sign In
            </Link>
          )}
          <Link
            to="/cart"
            data-testid="nav-cart"
            className="relative text-[#2b2520] transition-colors hover:text-[#a06d34]"
          >
            <ShoppingBag className="h-5 w-5" strokeWidth={1.5} />
            {count > 0 && (
              <span
                data-testid="cart-count"
                className="absolute -right-2 -top-2 flex h-4 min-w-4 items-center justify-center bg-[#c99a63] px-1 text-[10px] font-bold text-[#2b2520]"
              >
                {count}
              </span>
            )}
          </Link>
        </div>
      </div>
    </header>
  );
};
